export enum MaintenanceMediaTypes {
  Video = "video",
  Photo = "photo"
}